
      <div appMouseHandler [rgX]="1" (newValue)="setHue($event)" class="hue">
          <app-cursor [position]="cursorPosition"></app-cursor>
      </div>
    